<template>
  <v-row
    no-gutters
    dense
  >
    <v-col
      cols="8"
      offset="2"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card
          outlined
        >
          <v-card-text>
            <v-row
              dense
              no-gutters
            >
              <v-col
                cols="12"
              >
                <v-row
                  dense
                  align="center"
                >
                  <v-col
                    cols="6"
                    v-if="this.email"
                  >
                    <v-text-field
                      label="Email"
                      name="email"
                      prepend-icon="mdi-email"
                      type="text"
                      v-model="email"
                      :rules="[rules.required]"
                      readonly
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    v-if="this.username"
                  >
                    <v-text-field
                      label="Username"
                      name="username"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="username"
                      :rules="[rules.required]"
                      readonly
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="6"
                    v-if="this.username"
                  >
                    <v-text-field
                      label="Key"
                      name="key"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="key"
                      :rules="[]"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-switch
                      v-model="allServices"
                      label="All Services Access"
                      :disabled="!!accessSyncSourceId"
                    ></v-switch>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-autocomplete
                      :clearable="true"
                      label="Sync Access From Collaborator (Optional)"
                      v-model="accessSyncSourceId"
                      :items="collaboratorOptions"
                      :disabled="allServices"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-autocomplete
                      :clearable="true"
                      label="Services"
                      :multiple="true"
                      :chips="true"
                      v-model="services"
                      :items="availServices"
                      :disabled="allServices || !!accessSyncSourceId"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row
                  dense
                >
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="processing"
                      :disabled="processing"
                      @click="submitForm"
                    >Submit</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <div style="display:inline-block;
                      width: 96px;
                      height: 12px;
                      border-bottom: 1px solid black;
                      text-align: center;
                      margin-bottom: 8px;">
                      <span style="
                      font-weight: bold;
                      font-size: 12px; background-color: white; padding: 0 8px;">
                        OR
                      </span>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="processing"
                      :disabled="processing"
                      @click="saveAllSubmitForm"
                    >Select All And Submit</v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <div style="display:inline-block;
                      width: 96px;
                      height: 12px;
                      border-bottom: 1px solid black;
                      text-align: center;
                      margin-bottom: 8px;">
                      <span style="
                      font-weight: bold;
                      font-size: 12px; background-color: white; padding: 0 8px;">
                        OR
                      </span>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="processing"
                      :disabled="processing"
                      @click="removeAllSubmitForm"
                    >Remove All And Submit</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Update',
  data() {
    return {
      processing: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
      },
      loginMethod: 'email',
      email: '',
      username: '',
      key: '',
      valid: false,
      services: null,
      availServices: [],
      allServices: false,
      accessSyncSourceId: null,
      collaboratorOptions: [],
    };
  },
  created() {
    this.$api.get('partner/active-cpanel-services').then((response) => {
      this.$set(this, 'availServices', response.data);
    });
    this.$api.post('partner/collaborator/read', {
      id: this.$route.params.id,
    }).then((response) => {
      this.$set(this, 'services', response.data.services);
      this.email = response.data.collaborator.email;
      this.username = response.data.collaborator.username;
      this.allServices = !!response.data.collaborator.all_services;
      this.accessSyncSourceId = response.data.collaborator.access_sync_source_id || null;
    });
    this.$api.post('partner/collaborator/list', {
      per_page: -1,
      current_page: 1,
      search: {},
    }).then((response) => {
      const currentId = parseInt(this.$route.params.id, 10);
      const options = response.data.data
        .filter((item) => item.id !== currentId)
        .map((item) => ({
          text: item.email || item.username || `Collaborator #${item.id}`,
          value: item.id,
        }));
      this.$set(this, 'collaboratorOptions', options);
    });
  },
  watch: {
    allServices(val) {
      if (val) {
        this.accessSyncSourceId = null;
      }
    },
  },
  methods: {
    submitForm() {
      if (this.$refs.form.validate()) {
        this.$api.post('partner/collaborator/update', {
          id: this.$route.params.id,
          key: this.key,
          services: this.services,
          all_services: this.allServices ? 1 : 0,
          access_sync_source_id: this.accessSyncSourceId,
        })
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Collaborator is updated.',
            });
            window.location.reload();
          })
          .catch((error) => {
            if (error.response) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.response.data.message || error.response.data,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          })
          .finally(() => {
            this.processing = false;
          });
      }
    },
    saveAllSubmitForm() {
      if (this.$refs.form.validate()) {
        this.$api.post('partner/collaborator/update', {
          id: this.$route.params.id,
          key: this.key,
          services: null,
          all: 1,
          all_services: 0,
          access_sync_source_id: this.accessSyncSourceId,
        })
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Collaborator is updated.',
            });
            window.location.reload();
          })
          .catch((error) => {
            if (error.response) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.response.data.message || error.response.data,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          })
          .finally(() => {
            this.processing = false;
          });
      }
    },
    removeAllSubmitForm() {
      if (this.$refs.form.validate()) {
        this.$api.post('partner/collaborator/update', {
          id: this.$route.params.id,
          key: this.key,
          services: null,
          all_services: 0,
          access_sync_source_id: this.accessSyncSourceId,
        })
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Collaborator is updated.',
            });
            window.location.reload();
          })
          .catch((error) => {
            if (error.response) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.response.data.message || error.response.data,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          })
          .finally(() => {
            this.processing = false;
          });
      }
    },
  },
};
</script>

<style scoped>

</style>
